/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateSupportCaseRequest } from '../models/CreateSupportCaseRequest';
import type { PaginatedSupportCaseDto } from '../models/PaginatedSupportCaseDto';
import type { SupportCaseDto } from '../models/SupportCaseDto';
import type { SupportCaseImageResponse } from '../models/SupportCaseImageResponse';
import type { UpdateSupportCaseStatusRequest } from '../models/UpdateSupportCaseStatusRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class SupportCaseService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns SupportCaseDto OK
     * @throws ApiError
     */
    public createSupportCase({
        request,
    }: {
        request: CreateSupportCaseRequest,
    }): CancelablePromise<SupportCaseDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v2/support-cases/create-case',
            query: {
                'request': request,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns SupportCaseDto OK
     * @throws ApiError
     */
    public updateSupportCaseStatus({
        caseId,
        requestBody,
    }: {
        caseId: string,
        requestBody: UpdateSupportCaseStatusRequest,
    }): CancelablePromise<SupportCaseDto> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/v2/support-cases/{caseId}/status',
            path: {
                'caseId': caseId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns PaginatedSupportCaseDto OK
     * @throws ApiError
     */
    public searchSupportCases({
        shopId,
        search = '',
        sortBy = 'createdAt',
        direction = 'desc',
        page,
        limit = 20,
    }: {
        shopId: string,
        search?: string,
        sortBy?: string,
        direction?: string,
        page?: number,
        limit?: number,
    }): CancelablePromise<PaginatedSupportCaseDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/support-cases/{shopId}/search',
            path: {
                'shopId': shopId,
            },
            query: {
                'search': search,
                'sortBy': sortBy,
                'direction': direction,
                'page': page,
                'limit': limit,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns SupportCaseImageResponse OK
     * @throws ApiError
     */
    public getSupportCaseImage({
        caseId,
    }: {
        caseId: string,
    }): CancelablePromise<SupportCaseImageResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/support-cases/{caseId}/image',
            path: {
                'caseId': caseId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns SupportCaseDto OK
     * @throws ApiError
     */
    public getSupportCases(): CancelablePromise<Array<SupportCaseDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/support-cases/all',
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
